export default __webpack_public_path__ + "static/media/trophy-badge.a3ebfde5.svg";